export default "__VITE_ASSET__D7JuD8vq__"